module.exports = __webpack_public_path__ + "static/media/2give.9f370dcf.svg";